<template>
  <div>
    <div>
      <span class="xbed-sub-title">{{topTitle}}</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>营销管理</BreadcrumbItem>
        <BreadcrumbItem>标签管理</BreadcrumbItem>
        <BreadcrumbItem>{{topTitle}}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <Form @submit.native.prevent="preventSubmit" inline>
      <FormItem label='类型' :label-width='80'>
        <Select v-model="searchParams.tagType" filterable>
          <Option value="" key="">全部</Option>
          <Option v-for="(item, index) in alltypes" :value="item.id" :key="index">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label='状态' :label-width='80'>
        <Select ref="resetCity" v-model="searchParams.isEnabled" filterable>
          <Option value="">全部</Option>
          <Option v-for="(item, index) in allstatus" :value="item.id" :key="index">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem :label-width="10">
        <Button type="primary" @click="getTagGrouplistFn">查询</Button>
      </FormItem>
      <FormItem :label-width="10">
        <Button type="primary" @click="openAddTagGroupModalFn">新增标签组</Button>
      </FormItem>
    </Form>

    <div style="margin: 10px;overflow: hidden">
      <Page show-sizer show-total :page-size="pageParams.pageSize" :current="pageParams.pageNum" :total="pageParams.total" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>
    <Table stripe :columns="columnsList" :data='tagGrouplist' :loading='isloading'></Table>

    <!-- 新增编辑标签组 -->
    <Modal v-model="modalConfig.display" :title="modalConfig.title"  @on-ok="submitBtn">
      <Form :label-width="80" :model="modalConfig.data">
        <FormItem label="ID:" v-if="modalConfig.data.id">
          <span>{{modalConfig.data.id}}</span>
        </FormItem>
        <FormItem label="名称:" required>
          <Input v-model="modalConfig.data.name" placeholder="" style="width:300px;"></Input>
        </FormItem>

        <div v-if="!modalConfig.data.id">
          <FormItem label="类型:" required>
            <Select v-model="modalConfig.data.tagType" style="width:300px;">
              <Option :key="1" :value="1">用户标签</Option>
              <!-- <Option v-for="item in alltypes" :key="item.id" :value="item.id">{{item.name}}</Option> -->
            </Select>
          </FormItem>
        </div>
        
        <FormItem label="类型:" v-if="modalConfig.data.id">
          <span>{{['', '用户标签', '门店标签', '房间标签', '', '产品标签'][modalConfig.data.tagType]}}</span>
        </FormItem>

        <FormItem label="父标签组:">
          <Select v-model="modalConfig.data.parentId" style="width:300px;">
            <Option value="">无</Option>
            <Option v-for="item in parentTagAry" :key="item.id" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>

        <FormItem label="状态:" required>
          <Select v-model="modalConfig.data.isEnabled" style="width:300px;">
            <Option :value="0">停用</Option>
            <Option :value="1">启用</Option>
          </Select>
    
          <p style="color:red;margin-top:10px;" v-if="modalConfig.data.isEnabled == 0">* 标签组设置停用，包含的所有标签将统一停用</p>
          <p style="color:red;margin-top:10px;" v-if="modalConfig.data.isEnabled == 1">* 标签组设置启用，包含的标签需单独更新状态</p>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import API from "@/api";
import Utils from "../../utils";
export default {
  data(){
    return{
      topTitle: '标签组',
      parentTagAry: [],
      searchParams: {
        tagType: "",
        isEnabled: "",
      },
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      modalLoading:false,
      modalConfig: {
        title: '新增标签组',
        display: false,
        data: {
          id: '',
          name: '',
          tagType: 1,
          parentId: '',
          isEnabled: 1
        },
        defaultData: {
          id: '',
          name: '',
          tagType: 1,
          parentId: '',
          isEnabled: 1
        },
      },
      alltypes: [
        {id:1,name:'用户标签'},
        {id:2,name:'门店标签'}
      ],
      allstatus: [
        {id:0,name:'停用'},
        {id:1,name:'启用'}
      ],
      tagGrouplist: [],
      isloading: false,
      columnsList:[
        {
          title:'标签组ID',
          key:'id',
          align:'center',
          width:120
        },
        {
          title:'标签组名称',
          key:'name',
          align:'center',
          width:240
        },
        {
          title:'类型',
          key:'tagType',
          align:'center',
          width:120,
          render: (h, params) => {
            let type = ['', '用户标签', '门店标签', '房间标签', '', '产品标签'][params.row.tagType]
            return h('span', {}, type)
          }
        },
        {
          title:'状态',
          key:'isEnabled',
          align:'center',
          width:120,
          render: (h, params) => {
            let state = ['停用', '启用'][params.row.isEnabled]
            return h('span', {}, state)
          }
        },
        {
          title:'标签数',
          key:'tagNum',
          align:'center',
          width:120
        },
        {
          title:'操作',
          align:'center',
          width:340,
          render: (h, params) => {
            return h('div',[
              h('Button',{
                props: {
                  type: "primary",
                  size: "small"
                },
                style: {
                  marginRight: "10px"
                },
                on: {
                  click: () => {
                    this.openEditTagGroupModalFn(params.row)
                  }
                }
              },'编辑'),
              h('Button',{
                props: {
                  type: "primary",
                  size: "small"
                },
                style: {
                  marginRight: "10px"
                },
                on: {
                  click: () => {
                    this.forwardToTaglistPageFn(params.row.id, params.row.name, params.row.tagType)
                  }
                }
              },'标签列表'),
              h('Button',{
                props: {
                  type: "primary",
                  size: "small"
                },
                on: {
                  click: () => {
                    if (!Utils.hasPermission('tagDetailList')) {
                      this.$Notice.error({
                        title: "无权限操作"
                      });
                      return
                    }
                    if (params.row.tagType == 1) {
                      let _url = this.$router ? '#/app/marketing/tagDetailList' : '#/Market/Market/tagDetailList'
                      _url = `${_url}?tagType=${params.row.tagType}&groupId=${params.row.id}`
                      window.open(_url)
                    } else {
                      this.$Notice.error({
                        title: '门店明细暂未开放',
                      })
                    }
                  }
                }
              },['','用户明细','门店明细'][params.row.tagType]),
            ])
          }
        }
      ]
    }
  },

  created () {
    this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.userId = Utils.findFromLocalStorage( "vue-userid" );
    this.env = Utils.findFromLocalStorage( "env", "dev" );

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'secret': '58dbac0cb9a1db115a473199f8d312e6', // 本地请求 IP 域名才需要传 secret
    }

    if (!Utils.hasPermission('tagGroupList')) {
      this.$Notice.error({
        title: "无权限查看标签组"
      });
      return
    }
    this.getTagGrouplistFn()
  },

  methods: {
    async getTagGrouplistFn(){
      let params = {
        tagType: this.searchParams.tagType,
        isEnabled: this.searchParams.isEnabled,
        pageNum: this.pageParams.pageNum,
        pageSize: this.pageParams.pageSize,
      }
      try {
        let resp = (await API.omsAPI[this.env].clientServer.getTagGroupList(params, this.protHeaders)).data;
        this.isloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取标签组列表数据异常',
            desc: resp.msg
          })
          return
        }
        this.tagGrouplist = resp.list
        this.pageParams.total = resp.total
      } catch(e) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    changePageSize(pageSize) {
      this.pageParams.pageNum = 1;
			this.pageParams.pageSize = pageSize;
			this.getTagGrouplistFn();
    },

    changePage(page) {
      this.pageParams.pageNum = page;
			this.getTagGrouplistFn();
    },

    openAddTagGroupModalFn() {
      if (!Utils.hasPermission('tagGroupAdd')) {
        this.$Notice.error({
          title: "无权限操作"
        });
        return
      }
      this.getParentTagtypeListFn()
      this.modalConfig.data = Object.assign({}, this.modalConfig.defaultData)
      this.modalConfig.title = '新增标签组';
      this.modalConfig.display = true;
    },

    openEditTagGroupModalFn(obj) {
      if (!Utils.hasPermission('tagGroupEdit')) {
        this.$Notice.error({
          title: "无权限操作"
        });
        return
      }
      this.getParentTagtypeListFn(obj.id)
      this.modalConfig.data = Object.assign({}, this.modalConfig.defaultData, obj)
      this.modalConfig.title = '编辑标签组';
      this.modalConfig.display = true
    },

    submitBtn() {
      if (!this.modalConfig.data.name.trim()) {
        this.$Notice.error({
          title: '标签组名称不能为空',
        })
        return
      }
      let params = {
        name: this.modalConfig.data.name,
        tagType: this.modalConfig.data.tagType,
        parentId: this.modalConfig.data.parentId,
        isEnabled: this.modalConfig.data.isEnabled
      }
      if (this.modalConfig.data.id) {
        params.id = this.modalConfig.data.id
        this.editTagGroupFn(params)
      } else {
        this.addNewTagGroupFn(params)
      }
    },

    async addNewTagGroupFn(params) {
      try {
        let resp = await API.omsAPI[this.env].clientServer.addNewTagGroup(params, this.protHeaders);
        this.isloading = false
        if (resp.data.retCode) {
          this.$Notice.error({
            title: '新增标签组数据异常',
            desc: resp.data.msg
          })
          return
        }
        
        this.$Notice.success({
          title: '新增标签组成功',
        })
        this.pageParams.pageNum = 1
        this.getTagGrouplistFn()
      } catch(err) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    async editTagGroupFn(params) {
      try {
        let resp = await API.omsAPI[this.env].clientServer.editTagGroup(params, this.protHeaders);
        this.isloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '编辑标签组数据异常',
            desc: resp.msg
          })
          return
        }
        
        this.$Notice.success({
          title: '标签组编辑成功',
        })
        this.pageParams.pageNum = 1
        this.getTagGrouplistFn()
      } catch(err) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    forwardToTaglistPageFn(tagGroupId, tagGroupName, tagType) {
      if (!Utils.hasPermission('tagList')) {
        this.$Notice.error({
          title: "无权限操作"
        });
        return
      }
      let _url = this.$router ? '#/app/marketing/tagList' : '#/Market/Market/tagList'
      if (tagGroupId) {
        _url = `${_url}?id=${tagGroupId}&name=${tagGroupName}&tagType=${tagType}`
      }
      window.open(_url)
    },

    async getParentTagtypeListFn(TagId) {
      let params = {
        tagType: 1,
        id: TagId
      }
      try {
        let resp = (await API.omsAPI[this.env].clientServer.getTagGroupsByType(params, this.protHeaders)).data;
        this.isloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取同类型标签组数据异常',
            desc: resp.msg
          })
          return
        }
        this.parentTagAry = resp
      } catch(e) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }    
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/marketing/tagGroupList.vue